<app-vvr-icon [dark]="false" [full]="false" [overlay]="false" [shadow]="false"></app-vvr-icon>
<div class="container">
    <div class="topbar">
        <div class="title">
            <h1 class="h3 condensed">Reparatie</h1>
        </div>
        <div class="controls">
            <div
                class="fab small"
                id="btn-Exit"
                matTooltip="Terug naar meldingen"
                matTooltipPosition="below"
                routerLink="/repairs">
                <i class="fas fa-sign-out-alt"></i>
            </div>
        </div>
    </div>
    @if (form()) {
        <div>
            <form [formGroup]="form()">
                <div class="row">
                    <mat-form-field appearance="fill" class="col-md-6 col-lg-4">
                        <mat-label>Soort</mat-label>
                        <mat-select formControlName="type_id" placeholder="Soort">
                            @for (type of types; track type) {
                                <mat-option
                                    [value]="type.id">
                                    {{type.name}}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="fill" class="col-md-6 col-lg-4">
                        <mat-label>{{type?.licence_plate ? 'Kenteken' : 'Machinenummer'}}</mat-label>
                        <input
                            formControlName="machine_number"
                            id="machine_number"
                            matInput
                            name="machine_number"
                            placeholder="{{type?.licence_plate ? 'Kenteken' : 'Machinenummer'}}"
                            type="text">
                        @if (!type?.licence_plate) {
                            <mat-error>Dit veld mag maximaal 255 tekens bevatten</mat-error>
                        } @else {
                            <mat-error>Vul een geldig kenteken in</mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field appearance="fill" class="col-md-6 col-lg-4">
                        <mat-label>Status</mat-label>
                        <mat-select formControlName="status" placeholder="Status">
                            @for (status of statusList; track status) {
                                <mat-option [value]="status">
                                    {{status}}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="row">
                    <mat-form-field appearance="fill" class="col-md-12">
                        <mat-label>Beschrijving</mat-label>
                        <textarea
                            cdkAutosizeMinRows="4"
                            cdkTextareaAutosize
                            formControlName="description"
                            id="description"
                            matInput
                            name="description"
                            placeholder="Voeg hier eventuele notities en opmerkingen toe"
                            type="text">
                        </textarea>
                        <mat-error>Dit veld is verplicht</mat-error>
                    </mat-form-field>
                </div>
            </form>
            <div class="files">
                @for (file of repair().files; track file) {
                    <div class="file">
                        <div
                            (click)="openFile(file, repair().files)"
                            [class.is-img]="['jpg', 'jpeg', 'png'].indexOf(file.ext) !== -1"
                            [style.background-image]="(file.file.substr(0,4) !== 'http' ? url : '') + file.file+'?access_token='+token|safeBgUrl">
                            <div class="icon"><i class="fas fa-file fa-3x"></i></div>
                            <div class="filename">
                                {{file.name}}
                            </div>
                        </div>
                    </div>
                }
            </div>
            <div class="comments">
                <div class="title">
                    <h1 class="h3 condensed">Reacties</h1>
                    @if (!repair().id) {
                        Je moet het reparatieformulier eerst opslaan voordat je reacties kunt plaatsen
                    }
                </div>
                @if (repair().id) {

                    @for (comment of repair().comments; track comment) {
                        <app-repair-comment
                            (deleted)="deleteComment($event)"
                            (openFile)="openFile($event, comment.files)"
                            (placedComment)="addEmptyComment()"
                            (uploadFiles)="commentUploadFiles($event, comment)"
                            [repairComment]="comment">
                        </app-repair-comment>
                    }

                }
            </div>
        </div>
    }
    <div class="controls-bottom">
        @if (!isCordova) {
            <label matTooltip="Upload bestand" matTooltipPosition="before">
                <input (change)="uploadFile($event)" hidden multiple type="file">
                <div class="fab big">
                    @if (!uploading()) {
                        <i class="fas fa-upload"></i>
                    } @else {
                        <i class="fas fa-circle-notch fa-spin"></i>
                    }
                </div>
            </label>
        }
        @if (isCordova) {
            <div
                (click)="takePicture()"
                class="fab big"
                id="btn-AddImage"
                matTooltip="Camera"
                matTooltipPosition="before">
                <i class="fas fa-camera"></i>
            </div>
        }
        <div
            (click)="save(true)"
            [class.disabled]="saving()"
            class="fab big primary"
            id="btn-Save"
            matTooltip="Opslaan"
            matTooltipPosition="before">
            @if (!saving()) {
                <i class="fas fa-save"></i>
            } @else {
                <i class="fas fa-circle-notch fa-spin"></i>
            }
        </div>
    </div>
</div>

